/*
 * Filename: sfOtherOrgAuthSuccess.tsx
 * Description: component for sf auth success.
 */

import React from 'react';
import jsforce from 'jsforce';
import { observer } from 'mobx-react';
import TemplateConfigurationController from '../template-configuration/template-config.controller';


class CQSFOtherOrgAuthSuccessComponent extends React.Component {

    private readonly templateConfigCtrl: TemplateConfigurationController;
    constructor(props: any) {
        super(props);
        this.templateConfigCtrl = new TemplateConfigurationController();
    }
    componentDidMount() {
        const jsForce: any = jsforce;
        jsForce.browser.init();
    }

    render() {
        return (
            <></>
        );
    }
}

export const CQSFOtherOrgAuthSuccess = observer(CQSFOtherOrgAuthSuccessComponent);
